export default "__VITE_ASSET__b23Et6qc__"